import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from 'store/navigation/handler';

export const NavigationSetter: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};
